import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { BackgroundContainer } from '../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { HorizontalLine, VerticalLine, DiagonalLine } from '../../../components/Layout/Line';
import { UnOrderedList } from '../../../components/Layout/UnOrderedList';
import { Screen, SplitScreen, SplitScreenContentHolder } from '../../../components/Layout/Screen';
import Title from '../../../components/Title';

// Assets
import { device } from '../../../styles/variables';

const StyledScreen = Screen.extend`
  height: auto;
  padding: 0 0 50px 0;
  background-color: white;

  @media ${device.tablet} {
    height: 100%;
    padding: 0;
  }
`;

const StyledSplitScreen = SplitScreen.extend`
  position: relative;
  height: 100%;
  ${({ backgroundColor = 'none' }) => `
    background: ${backgroundColor};
  `};
  pointer-events: all;
`;

const TitleContainer = styled.div`
  margin: 53px 0 0 0;
  @media ${device.tablet} {
    margin: 68px 0 0 0;
  }
  @media ${device.laptopL} {
    margin: 154px 0 0 0;
  }

  .title {
    h2 {
      max-width: 774px;
    }
  }
`;

const TextHolder = styled.div`
  width: 100%;
  max-width: 620px;
  margin: 77px auto 0;
`;

const ContentSplitScreen = SplitScreen.extend`
  display: block;
  width: 100%;
  @media ${device.tablet} {
    display: inline-block;
    vertical-align: top;
    width: 50%;
  }
`;

const SpecificsScreen = () => (
  <StyledScreen>
    <BackgroundContainer>
      <HorizontalLine />
      <VerticalLine />
      <StyledSplitScreen>
        <SplitScreenContentHolder direction="right">
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
      <StyledSplitScreen>
        <SplitScreenContentHolder>
          <DiagonalLine />
          <VerticalLine />
        </SplitScreenContentHolder>
      </StyledSplitScreen>
    </BackgroundContainer>
    <ContentContainer>
      <TitleContainer>
        <Title className="title" primary={false}>
          We do everything that&apos;s needed, but if you want us to be more specific, we do:
        </Title>
      </TitleContainer>
      <TextHolder>
        <ContentSplitScreen>
          <UnOrderedList>
            <li>Strategy</li>
            <li>Project management</li>
            <li>Research</li>
            <li>Medical writing</li>
            <li>Branding</li>
            <li>Design</li>
            <li>Animation</li>
            <li>Front/back end development</li>
            <li>UX</li>
          </UnOrderedList>
        </ContentSplitScreen>
        <ContentSplitScreen>
          <UnOrderedList>
            <li>LMS/CMS building</li>
            <li>Testing</li>
            <li>Optimisation</li>
            <li>QA</li>
            <li>Analytics/tracking</li>
            <li>Hosting</li>
            <li>Film production</li>
            <li>Social media</li>
          </UnOrderedList>
        </ContentSplitScreen>
      </TextHolder>
    </ContentContainer>
  </StyledScreen>
);

export default connect()(SpecificsScreen);



// WEBPACK FOOTER //
// ./src/pages/Services/screens/Specifics.jsx